
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const profileRef = useRef(null); // Reference for profile container

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleProfile = () => setProfileOpen((prev) => !prev);

  useEffect(() => {
    // Close profile dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    };

    if (profileOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [profileOpen]);

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.removeItem('userToken');
    navigate('/login');
  };

  return (
    <nav className="header">
      <div className="logo">
        <Link to="/">
          <img src="https://www.gatnix.com/assets/images/gatnix-logo-svg.svg" alt="gatnix" className="gatnix" />
        </Link>
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        {menuOpen ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
        <li><Link to="/">Home</Link></li>
        <li className={`dropdown ${dropdownOpen ? 'open' : ''}`} onClick={toggleDropdown}>
          <Link to="/products">Products</Link>
        </li>
        <li><a href="https://www.gatnix.com/blog" target="_blank">Blog</a></li>
        <li><a href="https://www.gatnix.com/contact" target="_blank">Contact Us</a></li>
        <li><a href="https://www.gatnix.com/profile" target="_blank">Profiles</a></li>
        <li><a href="https://www.gatnix.com/home" target="_blank"><button className="buy-btn">Buy Gatnix</button></a></li>
      </ul>

      {/* Profile Section */}
      <div className="user-section" ref={profileRef}>
        <Avatar size="large" icon={<UserOutlined />} onClick={toggleProfile} />

        {profileOpen && (
          <div className="profile-container">
            <h4>Anjan Yelle</h4>
            <hr />
            <p className="logout-btn" onClick={handleLogout}>Logout</p>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
